import * as React from 'react'
import { withRouter } from 'next/router'
import { getSleepProps } from '../../models/Sleep'
import type { SleepPropsType } from '../../models/Sleep'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { DiscoverMenu } from '@components/Discover/DiscoverMenu'
import { TagPillRow } from '@components/Tag/TagPillRow'
import HorizontalMediumTrackRow from '@components/Discover/HorizontalMediumTrackRow'
import { config } from 'react-awesome-styled-grid'
import type { HorizontalMediumTrackRowPropsType } from '../../models/Discover'
import styled from 'styled-components'
function Sleep (props: SleepPropsType): React.ReactNode {
  return (
    <DiscoverLayout background title={'Listen to Sleep Sound Tracks on Dipsea'}>
      <div>
        <DiscoverMenu page={'sleep'}/>
        <TagPillRow tags={props.tags} id={'sleep'}/>
        {props.pageRows.map((rec: HorizontalMediumTrackRowPropsType, index: number): React.ReactNode => {
          return (<SectionSeparator key={`sleep-${props.id}-pagerow-${index}`}>
              {rec.displayType === 'horizontalMediumTrackRow' && <HorizontalMediumTrackRow {...rec}/> }
            </SectionSeparator>)
        }
        )}
      </div>
    </DiscoverLayout>
  )
}
export default withRouter(Sleep as any) as any

export async function getStaticProps (): Promise<{ props: SleepPropsType }> {
  const sleep = await getSleepProps()
  return { props: sleep }
}

const SectionSeparator = styled.div<any>`
    width: 100%;
    margin-top: 32px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
      margin-top: 48px;
    `}
`
